<div fxHide.lt-md class="newrule__header" [class.loading]="creating">
  <h2 fxLayout fxLayoutGap="12px">
    <span>Automate your tasks</span>
    <mat-spinner *ngIf="creating" diameter="32"></mat-spinner>
  </h2>
  <span class="subtitle">
    Save time by automating tasks. You can create rules to allow {{ 'CORE.PRODUCT_NAME' | transloco }} to create tasks
    on your behalf.
  </span>
  <span class="rules__close-btn" (click)="dismissModal()">
    <img src="/assets/iconography/cancel.svg" width="24px" height="24px" />
  </span>
</div>

<div class="newrule__body" [class.loading]="creating" fxLayout fxLayout.lt-md="column">
  <div fxFlex>
    <h3>Cleaning</h3>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createTaskRule(1, -3600, 'checkin')">
      <img src="/assets/iconography/gx-create/check-out.svg" />
      <span class="newrule__option strong" data-intercom-target="cleaning-before-checkin" fxFlex>Before check-in</span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createTaskRule(1, 3600, 'checkout')">
      <img src="/assets/iconography/gx-create/check-out.svg" />
      <span class="newrule__option strong" data-intercom-target="cleaning-after-checkout" fxFlex>After check-out</span>
    </div>
  </div>

  <div fxFlex>
    <h3>Check-in</h3>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createTaskRule(2, -3600, 'checkin')">
      <img src="/assets/iconography/gx-create/check-in.svg" />
      <span class="newrule__option strong" data-intercom-target="checkin-before-checkin" fxFlex>Before check-in</span>
    </div>
  </div>

  <div fxFlex>
    <h3>Check-out</h3>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createTaskRule(4, -3600, 'checkout')">
      <img src="/assets/iconography/gx-create/check-out.svg" />
      <span class="newrule__option strong" data-intercom-target="checkout-before-checkout" fxFlex>
        Before check-out
      </span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createTaskRule(4, 3600, 'checkout')">
      <img src="/assets/iconography/gx-create/check-out.svg" />
      <span class="newrule__option strong" data-intercom-target="checkout-after-checkout" fxFlex>After check-out</span>
    </div>
  </div>

  <div fxFlex>
    <h3>Maintenance</h3>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createTaskRule(5, -3600, 'recurring')">
      <sbnb-icon icon="sync" class="text-smoke-darker"></sbnb-icon>
      <span class="newrule__option strong" data-intercom-target="maintenance-recurring" fxFlex>Recurring</span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createTaskRule(5, -3600, 'checkin')">
      <img src="/assets/iconography/gx-create/check-in.svg" />
      <span class="newrule__option strong" data-intercom-target="maintenance-before-checkin" fxFlex>
        Before check-in
      </span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createTaskRule(5, 3600, 'checkin')">
      <img src="/assets/iconography/gx-create/check-in.svg" />
      <span class="newrule__option strong" data-intercom-target="maintenance-after-checkin" fxFlex>After check-in</span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createTaskRule(5, -3600, 'checkout')">
      <img src="/assets/iconography/gx-create/check-out.svg" />
      <span class="newrule__option strong" data-intercom-target="maintenance-before-checkout" fxFlex>
        Before check-out
      </span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createTaskRule(5, 3600, 'checkout')">
      <img src="/assets/iconography/gx-create/check-out.svg" />
      <span class="newrule__option strong" data-intercom-target="maintenance-after-checkout" fxFlex>
        After check-out
      </span>
    </div>
  </div>
</div>
